import React from 'react';
import PropTypes from 'prop-types';
import { SubTitle } from 'components';
import IconIncrease from 'assets/icons/icon-increase.svg';
import IconDecrease from 'assets/icons/icon-decrease.svg';
import './PastPerformanceV2.scss';
import { FormattedMessage } from 'react-intl';

const PastPerformanceV2 = (props) => {
  /** Change time period to months and years */
  const parseTimePeriod = (val) => {
    switch (val) {
      case 'M3':
        return '3 months';
      case 'M6':
        return '6 months';
      case 'M12':
        return '12 months';
      case 'M36':
        return '3 years';
      case 'M60':
        return '5 years';
      case 'M255':
        return '20+ years';
      default:
        return val;
    }
  };

  return (
    <div className="past-performance-v2">
      <SubTitle title={<FormattedMessage id="pastPerformance" />} />
      <section className="past-performance-v2__body">
        { props.data && props.data.map((item, idx) => (
          <div className="past-performance-v2__body__item" key={`performance-${idx}`}>
            <span className="year">
              {parseTimePeriod(item.timePeriod)}
            </span>

            {props.productType === 'markaz_real_estate' ? <small><FormattedMessage id="annualTotal" /></small> 
              : item.annualized && <small><FormattedMessage id="annualized" /></small>}
            {!item.annualized && !(item.timePeriod === 'M3' || item.timePeriod === 'M6' || item.timePeriod === 'M12') && <small><FormattedMessage id="cumulative" /></small>}

            <div className="value">
              <span className="value__icon">
                <img src={item.value <= 0 ? IconDecrease : IconIncrease} alt="icon" />
              </span>
              <span className="value__percentage">
                {`${item.value <= 0 ? '' : '+'}${Number(item.value).toFixed(2)}%`}
              </span>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

PastPerformanceV2.propTypes = {
  /** past performance data */
  data: PropTypes.arrayOf(PropTypes.object),
  /** product type */
  productType: PropTypes.string,
};

PastPerformanceV2.defaultProps = {
  data: [],
  productType: null,
};

export default PastPerformanceV2;
